import { Button, Container, Stack, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import { useNavigate, Link } from "react-router-dom";

const Signup = () => {
  // Accessing global user state and dispatch function from context
  const { userState, dispatch } = useContext(UserContext);

  // Local state variables for form inputs and error messages
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  // Hook for programmatic navigation
  const navigate = useNavigate();

  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    // Input validation checks
    if (!fname) {
      setError("first name is required");
      return;
    }

    if (!username) {
      setError("username required");
      return;
    }
    if (!password) {
      setError("password is required");
      return;
    }

    // Ensure password meets length requirement
    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      setPassword(""); // Clear the password field
      return;
    }

    // Check if username already exists in localStorage
    const existingUsername = localStorage.getItem(username);

    if (existingUsername !== null) {
      setUsername(""); // Clear the username field
      setError("Username already exists! Try another one.");
      return;
    } else {
      // Creating new user state object
      const newState = {
        ...userState,
        username,
        email,
        password,
      };

      // Dispatching signup action to update global state
      dispatch({
        type: "signup",
        payload: { username, fname, lname, email, password },
      });

      // Storing user data in localStorage
      localStorage.setItem(username, JSON.stringify(newState));
      localStorage.setItem("currentUser", JSON.stringify(newState));

      // Redirecting to home page after successful signup
      navigate("/");
    }
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          width: "300px",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "50px",
          margin: "auto",
          gap: "10px",
        }}
        onSubmit={handleSubmit} // Handling form submission
      >
        {/* Name input fields */}
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <TextField
            label="first name"
            value={fname}
            onChange={(e) => setFname(e.target.value)} // Updating first name state
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "gray",
                  borderWidth: "2px",
                },
              },
            }}
          />
          <TextField
            label="last name"
            value={lname}
            onChange={(e) => setLname(e.target.value)} // Updating last name state
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "gray",
                  borderWidth: "2px",
                },
              },
            }}
          />
        </Stack>

        {/* Username input field */}
        <TextField
          label="username"
          value={username}
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "gray",
                borderWidth: "2px",
              },
            },
          }}
          onChange={(e) => setUsername(e.target.value)} // Updating username state
        />

        {/* Email input field */}
        <TextField
          label="email"
          type="email"
          value={email}
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "gray",
                borderWidth: "2px",
              },
            },
          }}
          onChange={(e) => setEmail(e.target.value)} // Updating email state
        />

        {/* Password input field */}
        <TextField
          label="password"
          type="password"
          value={password}
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "gray",
                borderWidth: "2px",
              },
            },
          }}
          onChange={(e) => setPassword(e.target.value)} // Updating password state
        />

        {/* Signup button */}
        <Button type="submit" variant="contained">
          Sign Up
        </Button>

        {/* Error message display */}
        <Typography
          color="error"
          sx={{
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          {error}
        </Typography>

        {/* Redirect to login page if user already has an account */}
        <Typography
          sx={{
            fontSize: "15px",
            color: "white",
          }}
        >
          Already have an account?{" "}
          <Link
            to="/login"
            style={{
              textDecoration: "none",
              color: "#C9A227",
            }}
          >
            Log In
          </Link>
        </Typography>
      </form>
    </Container>
  );
};

export default Signup;
